import { Component, OnInit, Input, Output, EventEmitter, Inject, HostListener } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent extends BaseComponent implements OnInit {

  static RESULT_NO = "no";
  static RESULT_YES = "yes";

  isOpen = false;
  @Input() title = "";
  @Input() confirmationModal = false;
  @Input() okModal = false;
  @Input() longModal = false;
  @Input() fixedHeight = false;
  @Input() positiveText: string = this.getString("yes");
  @Input() negativeText: string = this.getString("no");
  @Input() positiveColor = "#FFF";
  @Input() negativeColor = "#FFF";
  @Input() positiveBgColor = "#00BAF7";
  @Input() negativeBgColor = "#CCC";
  @Input() showCloseButton = true;
  @Input() confirmClose = false;
  @Input() closeConfirmationTitle = "";
  @Input() closeConfirmationText = "";
  @Input() closeConfirmationPositiveText = "";
  @Input() closeConfirmationNegativeText = "";

  @Output() onResult = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onOpen = new EventEmitter();

  showCloseConfirmation = false;

  constructor(
    @Inject(DOCUMENT) private dom: Document,
  ) {
    super();
  }

  ngOnInit() {
  }

  open() {
    this.isOpen = true;
    this.dom.body["style"].overflow = "hidden";
    this.dom.body["style"].width = "100%";
    this.onOpen.emit();
  }

  close() {
    this.isOpen = false;
    this.showCloseConfirmation = false;
    this.dom.body["style"].overflow = "";
    this.dom.body["style"].position = "";
    this.onClose.emit();
  }

  requestClose() {
    if (this.confirmClose) {
      this.showCloseConfirmation = true;
      return;
    }
    this.close();
  }

  confirmCloseClicked() {
    this.close();
  }

  cancelCloseClicked() {
    this.showCloseConfirmation = false;
  }

  getCloseConfirmationTitle(): string {
    return this.closeConfirmationTitle || this.getString("closeUnsavedChangesTitle");
  }

  getCloseConfirmationText(): string {
    return this.closeConfirmationText || this.getString("closeUnsavedChangesConfirmation");
  }

  getCloseConfirmationPositiveText(): string {
    return this.closeConfirmationPositiveText || this.getString("discardChanges");
  }

  getCloseConfirmationNegativeText(): string {
    return this.closeConfirmationNegativeText || this.getString("keepEditing");
  }

  yesClicked() {
    this.onResult.emit(ModalComponent.RESULT_YES);
    this.close();
  }

  noClicked() {
    this.onResult.emit(ModalComponent.RESULT_NO);
    this.close();
  }

  closeOnBackdropClick(event: MouseEvent) {
    // Only close if clicking directly on the backdrop (modal overlay), not on the content
    if (event.target === event.currentTarget && this.showCloseButton) {
      this.requestClose();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.isOpen && event.key === "Escape" && this.showCloseButton) {
      if (this.showCloseConfirmation) {
        this.cancelCloseClicked();
        return;
      }
      this.requestClose();
    }
  }

}
